<template>
  <v-container class="db-tableau">
    <p v-if="url==='' || token===''">Loading...</p>
    <div ref="tableauViz" style="width: 100%; height: 827px;"></div>
  </v-container>
</template>
<script>

import {getTableauToken} from "../api/routes";
import {TableauViz} from '../../public/tableau.embedding.3.min.js';


export default {
  name: "IframeDashboards",
  data: () => ({
    url: '',
    token: '',
    hideTabs: false,
  }),
  methods:{
    redirectToList: function (){
      this.$router.push("/list");
    },
    init: function (){
      console.log('init called');
      this.$nextTick(function () {
        const viz = new TableauViz();
        viz.src = "https://dub01.online.tableau.com/t/cypheme/views/"+this.url;
        viz.token = this.token;
        viz.toolbar = 'hidden';
        viz.hideTabs = this.hideTabs;
        this.$refs.tableauViz.appendChild(viz);
      });
    },
  },
  mounted() {
    try {
      this.url = JSON.parse(sessionStorage.getItem('USER')).user.url.trim();
      if(this.url === '')
        this.redirectToList()

      let user_data = JSON.parse(sessionStorage.getItem('USER'))
      console.log(['user_data', user_data])
      if (user_data.user.htabs !== undefined && user_data.user.htabs) {
        this.hideTabs = false;
      }

      getTableauToken().then(resp => {
        this.token = resp.data.token;
        this.init();
      }).catch(error => {
        console.log(error)
      });

    } catch (e) {
      this.redirectToList()
    }
  }
}
</script>
<style scoped>
.container.db-tableau {
  padding: 0;
  margin: 0;
}
</style>
